import { render, staticRenderFns } from "./mallDetailHeader.vue?vue&type=template&id=d8353418&scoped=true&"
import script from "./mallDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./mallDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./mallDetailHeader.vue?vue&type=style&index=0&id=d8353418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8353418",
  null
  
)

export default component.exports